import React from 'react';
import { OrderedSet } from 'immutable';

import { GROUP_OF_ODDS_CLASS } from '../../../constants';
import Odd from '../../Odd';

import './groupOfOdds.scss';

interface Props {
    betslipOddIds: OrderedSet<string>;
    isLastGroup: boolean;
}

const GroupOfOdds: React.FC<Props> = ({ betslipOddIds, isLastGroup }) => {
    const firstBetslipOddId = betslipOddIds.first<undefined>();
    const lastBetslipOddId = betslipOddIds.last<undefined>();

    return (
        <div className={GROUP_OF_ODDS_CLASS} styleName="container">
            {betslipOddIds.map(betslipOddId => {
                const isFirst = betslipOddId === firstBetslipOddId;
                const isLast = betslipOddId === lastBetslipOddId;

                return (
                    <Odd
                        key={betslipOddId}
                        betslipOddId={betslipOddId}
                        isFirst={isFirst}
                        isLast={isLast}
                    />
                );
            })}
        </div>
    );
};

export default React.memo(GroupOfOdds);
